module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/humidifier-33539fbff31dc2be28f032bf2fe4e9b7.svg";